import { defineComponent as R, computed as a, useSlots as D, createElementBlock as o, openBlock as l, normalizeClass as d, createElementVNode as v, createBlock as m, createCommentVNode as n, toDisplayString as s, resolveDynamicComponent as T, withCtx as c, createTextVNode as f, renderSlot as S, createVNode as I, unref as g, mergeProps as A } from "vue";
import { RevButton as h } from "@ds/components/Button";
import { RevIllustration as $ } from "@ds/components/Illustration";
import { isString as j } from "../../utils/isString.js";
import { isValidNumber as y } from "../../utils/isValidNumber.js";
import { tw as e } from "../../utils/tailwind.js";
const E = {
  key: 0,
  class: "text-static-default-low body-2 mb-2"
}, z = {
  key: 1,
  class: "text-static-default-low body-1"
}, W = {
  key: 2,
  class: "mt-20 hidden md:block"
}, M = /* @__PURE__ */ R({
  name: "RevContentBlock",
  __name: "ContentBlock",
  props: {
    hasRoundedContainer: { type: Boolean, default: !1 },
    buttonDisabled: { type: Boolean, default: !1 },
    buttonLabel: { default: () => {
    } },
    target: { default: "_self" },
    buttonLoading: { type: Boolean, default: !1 },
    hasRoundedImage: { type: Boolean, default: !1 },
    buttonLoadingAlternativeText: {},
    buttonVariant: { default: "primary" },
    imageLeft: { type: Boolean, default: !1 },
    imageProps: {},
    surtitle: {},
    title: {},
    titleTag: { default: "h2" },
    titleVariant: { default: "title1" },
    to: {}
  },
  emits: ["click"],
  setup(t) {
    const x = a(() => [
      e`flex flex-col md:flex-row md:items-center`,
      t.hasRoundedContainer && e`rounded-lg overflow-hidden`
    ]), k = a(() => [
      e`text-static-default-hi mb-8`,
      t.titleVariant === "punchline" && e`punchline`,
      t.titleVariant === "title1" && e`heading-1`,
      t.titleVariant === "title2" && e`heading-2`
    ]), C = a(() => [
      e`w-full`,
      t.hasRoundedImage && e`rounded-lg overflow-hidden`
    ]), w = a(() => [
      e`min-w-[40%] flex-initial items-center justify-center md:mb-0 md:w-448 md:min-w-448`,
      t.imageLeft ? e`mb-16` : e`order-1 md:ml-auto`
    ]), L = a(() => [
      e`flex flex-col justify-center md:mb-0`,
      t.imageLeft ? e`order-1 md:ml-56 md:mr-0` : e`mb-16 md:mr-56`
    ]), b = a(() => t.buttonLabel !== void 0), B = a(() => !!t.surtitle), V = D(), N = a(() => !!V), P = a(
      () => j(t.imageProps.src) && y(t.imageProps.height) && y(t.imageProps.width)
    );
    return (u, i) => (l(), o("div", {
      class: d(x.value)
    }, [
      v("div", {
        class: d(L.value)
      }, [
        B.value ? (l(), o("p", E, s(t.surtitle), 1)) : n("", !0),
        (l(), m(T(t.titleTag), {
          class: d(k.value)
        }, {
          default: c(() => [
            f(s(t.title), 1)
          ]),
          _: 1
        }, 8, ["class"])),
        N.value ? (l(), o("div", z, [
          S(u.$slots, "default")
        ])) : n("", !0),
        b.value ? (l(), o("div", W, [
          I(g(h), {
            disabled: t.buttonDisabled,
            loading: t.buttonLoading,
            "loading-alternative-text": t.buttonLoadingAlternativeText,
            target: t.target,
            to: t.to,
            variant: t.buttonVariant,
            onClick: i[0] || (i[0] = (r) => u.$emit("click", r))
          }, {
            default: c(() => [
              f(s(t.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to", "variant"])
        ])) : n("", !0)
      ], 2),
      v("div", {
        class: d(w.value)
      }, [
        P.value ? (l(), m(g($), A({ key: 0 }, t.imageProps, {
          alt: t.imageProps.alt || "",
          class: C.value
        }), null, 16, ["alt", "class"])) : n("", !0)
      ], 2),
      b.value ? (l(), m(g(h), {
        key: 0,
        class: "order-2 mt-20 md:!hidden",
        "data-test": "small-screen-button",
        disabled: t.buttonDisabled,
        "full-width": "always",
        loading: t.buttonLoading,
        "loading-alternative-text": t.buttonLoadingAlternativeText,
        target: t.target,
        to: t.to,
        variant: t.buttonVariant,
        onClick: i[1] || (i[1] = (r) => u.$emit("click", r))
      }, {
        default: c(() => [
          f(s(t.buttonLabel), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading", "loading-alternative-text", "target", "to", "variant"])) : n("", !0)
    ], 2));
  }
});
export {
  M as default
};
